import styled from 'styled-components';

export const StyledButton = styled.button<{ $small?: boolean }>`
	padding: ${({ $small }) => ($small ? '0.25rem 1rem' : '0.75rem 1.5rem')};
	background: transparent;
	background-repeat: no-repeat !important;
	background-size: contain !important;
	border-radius: 4px;
	border: none;
	outline: none;
	font-weight: 400;
	font-size: ${({ $small }) => ($small ? '1.2rem' : '1.3rem')};
	text-align: center;
	font-family: ${({ theme }) => theme.FONTS_PRIMARY};
	display: flex;
	justify-content: center;
	flex-direction: row;
	align-items: center;
	white-space: nowrap;
	box-shadow: none;
	column-gap: 0.75rem;

	transition:
		background 0.25s,
		transform 0.25s,
		opacity 0.25s,
		color 0.25s,
		border-color 0.25s !important;
	&:disabled {
		cursor: not-allowed;
		opacity: 0.4;
	}

	@media (max-width: 525px) {
		font-size: 1.1rem;
		padding-inline: 0.75rem;
	}
`;

export const ButtonGrey = styled(StyledButton)`
	background: ${({ theme }) => theme.button_grey_bg};
	color: ${({ theme }) => theme.button_grey_fg};
	border: 1px solid ${({ theme }) => theme.button_grey_border};
	&:hover:enabled {
		background: ${({ theme }) => theme.button_grey_bg_hover};
		border-color: ${({ theme }) => theme.button_grey_border_hover};
	}
	svg {
		width: auto;
		height: 1rem;
		fill: ${({ theme }) => theme.button_grey_fg};
	}
`;

export const ButtonWhite = styled(StyledButton)`
	background: ${({ theme }) => theme.button_white_bg};
	color: ${({ theme }) => theme.button_white_fg};
	border: 1px solid ${({ theme }) => theme.button_white_border};
	&:hover:enabled {
		background: ${({ theme }) => theme.button_white_bg_hover};
		border-color: ${({ theme }) => theme.button_white_border_hover};
	}
	svg {
		width: auto;
		height: 1rem;
		fill: ${({ theme }) => theme.button_white_fg};
	}
`;

export const ButtonRed = styled(StyledButton)`
	background: ${({ theme }) => theme.button_red_bg};
	color: ${({ theme }) => theme.button_red_fg};
	border: 1px solid ${({ theme }) => theme.button_red_border};
	&:hover:enabled {
		background: ${({ theme }) => theme.button_red_bg_hover};
		border-color: ${({ theme }) => theme.button_red_border_hover};
	}
	svg {
		width: auto;
		height: 1rem;
		fill: ${({ theme }) => theme.button_red_fg};
	}
`;

export const ButtonGreen = styled(StyledButton)<{ $focus?: boolean }>`
	background: ${({ theme }) => theme.button_green_bg};
	color: ${({ theme }) => theme.button_green_fg};
	border: 1px solid ${({ theme }) => theme.button_green_border};
	${({ $focus, theme }) =>
		$focus
			? `
			background: ${theme.button_green_bg_hover};
			border-color: ${theme.button_green_border_hover};`
			: ''}
	&:hover:enabled {
		background: ${({ theme }) => theme.button_green_bg_hover};
		border-color: ${({ theme }) => theme.button_green_border_hover};
	}
	svg {
		width: auto;
		height: 1rem;
		fill: ${({ theme }) => theme.button_red_fg};
	}
`;

export const ButtonPurple = styled(StyledButton)<{ $focus?: boolean }>`
	background: ${({ theme }) => theme.button_purple_bg};
	color: ${({ theme }) => theme.button_purple_fg};
	border: 1px solid ${({ theme }) => theme.button_purple_border};
	${({ $focus, theme }) =>
		$focus
			? `
			background: ${theme.button_purple_bg_hover};
			border-color: ${theme.button_purple_border_hover};`
			: ''}
	&:hover:enabled {
		background: ${({ theme }) => theme.button_purple_bg_hover};
		border-color: ${({ theme }) => theme.button_purple_border_hover};
	}
	svg {
		width: auto;
		height: 1rem;
		fill: ${({ theme }) => theme.button_purple_fg};
	}
`;

export const ButtonOrange = styled(StyledButton)<{ $focus?: boolean }>`
	background: ${({ theme }) => theme.button_orange_bg};
	color: ${({ theme }) => theme.button_orange_fg};
	border: 1px solid ${({ theme }) => theme.button_orange_border};
	${({ $focus, theme }) =>
		$focus
			? `
			background: ${theme.button_orange_bg_hover};
			border-color: ${theme.button_orange_border_hover};`
			: ''}
	&:hover:enabled {
		background: ${({ theme }) => theme.button_orange_bg_hover};
		border-color: ${({ theme }) => theme.button_orange_border_hover};
	}
	svg {
		width: auto;
		height: 1rem;
		fill: ${({ theme }) => theme.button_orange_fg};
	}
`;

export const ButtonYellow = styled(StyledButton)`
	background: ${({ theme }) => theme.button_yellow_bg};
	color: ${({ theme }) => theme.button_yellow_fg};
	border: 1px solid ${({ theme }) => theme.button_yellow_border};
	&:hover:enabled {
		background: ${({ theme }) => theme.button_yellow_bg_hover};
		border-color: ${({ theme }) => theme.button_yellow_border_hover};
	}
	svg {
		width: auto;
		height: 1rem;
		fill: ${({ theme }) => theme.button_yellow_fg};
	}
`;

export const ButtonDark = styled(StyledButton)`
	background: ${({ theme }) => theme.button_dark_bg};
	color: ${({ theme }) => theme.button_dark_fg};
	border: 1px solid ${({ theme }) => theme.button_dark_border};
	&:hover:enabled {
		background: ${({ theme }) => theme.button_dark_bg_hover};
		border-color: ${({ theme }) => theme.button_dark_border_hover};
	}
	svg {
		width: auto;
		height: 1rem;
		fill: ${({ theme }) => theme.button_dark_fg};
	}
`;

export const ButtonDarkHighlighted = styled(StyledButton)<{ $focus?: boolean }>`
	background: ${({ theme, $focus }) =>
		$focus ? theme.button_dark_highlight_bg_hover : theme.button_dark_highlight_bg};
	color: ${({ theme, $focus }) => ($focus ? theme.button_dark_highlight_fg_hover : theme.button_dark_highlight_fg)};
	border: 1px solid
		${({ theme, $focus }) =>
			$focus ? theme.button_dark_highlight_border_hover : theme.button_dark_highlight_border};
	&:hover:enabled {
		background: ${({ theme }) => theme.button_dark_highlight_bg_hover};
		border-color: ${({ theme }) => theme.button_dark_highlight_border_hover};
		color: ${({ theme }) => theme.button_dark_highlight_fg_hover};
	}
	svg {
		width: auto;
		height: 1rem;
		fill: ${({ theme, $focus: $active }) =>
			$active ? theme.button_dark_highlight_fg_hover : theme.button_dark_highlight_fg};
	}
`;
